import './ResourceTabs.scss';
import { useRef } from 'react';
import ResourceTabMobile from './ResourceTabMobile.jsx';
import ResourceTabsSearchResults from './ResourceTabsSearchResults.jsx';

export default function ResourceTabsMobile(props) {

  const { resources, categories, searchQuery, activeTab, setActiveTab } = props;
  const containerRef = useRef();

  return (
    <div className="resource-tabs-accordion" ref={containerRef}>
      <div className="resource-tab-wrapper">

        {activeTab === 'search' && (
          <ResourceTabMobile
            category={{
              name: `Search: "${searchQuery}"`,
              id: 'search'
            }}
            resources={resources}
            activeTab={activeTab}
            containerRef={containerRef}
          >
            <ResourceTabsSearchResults resources={resources.filter(r => r.title.toLowerCase().includes(searchQuery.toLowerCase()))} categories={categories}/>
          </ResourceTabMobile>
        )}

        {/* Render a tab for each top-leve category */}

        {categories
          .filter(c => c.parent === null)
          .map(category => (
            <ResourceTabMobile
              key={category.id}
              category={category}
              subcategories={categories.filter(cat => cat?.parent?.id === category.id)}
              resources={resources.filter(r => r?.category?.some(c => c.parent?.id === category.id))}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              containerRef={containerRef}
            />
          ))
        }

      </div>
    </div>
  );
}